syntax = "proto2";

package com.scalableminds.webknossos.datastore;

import "geometry.proto";
import "MetadataEntry.proto";
import "IdWithBool.proto";

message Node {
  required int32 id = 1;
  required Vec3IntProto position = 2;
  required Vec3DoubleProto rotation = 3;
  required float radius = 4;
  required int32 viewport = 5;
  required int32 mag = 6;
  required int32 bitDepth = 7;
  required bool interpolation = 8;
  required int64 createdTimestamp = 9;
  repeated AdditionalCoordinateProto additionalCoordinates = 10;
}

message Edge {
  required int32 source = 1;
  required int32 target = 2;
}

message Comment {
  required int32 nodeId = 1;
  required string content = 2;
}

message BranchPoint {
  required int32 nodeId = 1;
  required int64 createdTimestamp = 2;
}

enum TreeTypeProto {
  DEFAULT = 0;
  AGGLOMERATE = 1;
}

message TreeBody {
  repeated Node nodes = 1;
  repeated Edge edges = 2;
}

message TreeAgglomerateInfoProto {
  required int64 agglomerateId = 1;
  optional string tracingId = 2;
  optional string mappingName = 3;
}

message Tree {
  required int32 treeId = 1;
  repeated Node nodes = 2; // empty for skeletons with storedWithExternalTreeBodies=true
  repeated Edge edges = 3; // empty for skeletons with storedWithExternalTreeBodies=true
  optional ColorProto color = 4;
  repeated BranchPoint branchPoints = 5;
  repeated Comment comments = 6;
  required string name = 7;
  required int64 createdTimestamp = 8;
  optional int32 groupId = 9;
  optional bool isVisible = 10; // `None` means `true`
  optional TreeTypeProto type = 11;
  optional bool edgesAreVisible = 12; // `None` means `true`
  repeated MetadataEntryProto metadata = 13;
  optional TreeAgglomerateInfoProto agglomerateInfo = 14;
}

message TreeGroup {
  required string name = 1;
  required int32 groupId = 2;
  repeated TreeGroup children = 3;
  optional bool isExpanded = 4;
}

message SkeletonUserStateProto {
  required string userId = 1;
  optional int32 activeNodeId = 2;
  repeated Id32WithBool treeGroupExpandedStates = 3;
  repeated Id32WithBool boundingBoxVisibilities = 4;
  repeated Id32WithBool treeVisibilities = 5;
}

message SkeletonTracing {
  required string datasetName = 1; // used when parsing and handling nmls, not used in tracing store anymore, do not rely on correct values
  repeated Tree trees = 2;
  required int64 createdTimestamp = 3;
  optional BoundingBoxProto boundingBox = 4;
  optional int32 activeNodeId = 5;
  required Vec3IntProto editPosition = 6;
  required Vec3DoubleProto editRotation = 7;
  required double zoomLevel = 8;
  required int64 version = 9;
  optional BoundingBoxProto userBoundingBox = 10;
  repeated TreeGroup treeGroups = 11;
  repeated NamedBoundingBoxProto userBoundingBoxes = 12;
  optional string organizationId = 13; // used when parsing and handling nmls, not used in tracing store anymore, do not rely on correct values
  repeated AdditionalCoordinateProto editPositionAdditionalCoordinates = 21;
  repeated AdditionalAxisProto additionalAxes = 22; // Additional axes for which this tracing is defined
  optional bool storedWithExternalTreeBodies = 23; // Only set to true on storing. If false, all trees will be stored
  repeated SkeletonUserStateProto userStates = 24;
}

message SkeletonTracingOpt {
  optional SkeletonTracing tracing = 1;
}

message SkeletonTracings {
  repeated SkeletonTracingOpt tracings = 1;
}

message StringOpt {
  optional string stringValue = 1;
}

message SkeletonTracingsWithIds {
  repeated SkeletonTracingOpt tracings = 1;
  repeated StringOpt annotationId = 2;
  repeated StringOpt tracingId = 3;
}
